function getSiteHost() {
  const globalObj = getGlobalObject();
  if (globalObj?.commonConfig) {
    return globalObj.commonConfig.host || 'EDITOR';
  }

  return 'EDITOR';
}

export function isHostStudio() {
  return getSiteHost() === 'STUDIO';
}

export function isHostEditor3() {
  return getSiteHost() === 'EDITOR3';
}

export function isHostStudio2() {
  return getSiteHost() === 'STUDIO2';
}

export function isBuilderEditor() {
  return isHostEditor3() || isHostStudio2();
}

export type SiteHost = 'EDITOR' | 'STUDIO' | 'EDITOR3' | 'STUDIO2';

export type GlobalWithCommonConfig = typeof globalThis & {
  commonConfig?: {
    host?: SiteHost;
    bsi?: string;
  };
};

export function getGlobalObject(): GlobalWithCommonConfig | undefined {
  if (typeof globalThis === 'object') {
    return globalThis;
  } else if (typeof self === 'object') {
    return self;
  } else if (typeof global === 'object') {
    return global;
  }
}
